<div class="fluxo-diario-container">
  <div class="topo-relatorio">
    <div class="titulo-relatorio">Fluxo de Caixa Diario Projetado</div>
  </div>

  <div class="filtros-relatorio">
    <div class="d-flex align-items-center flex-wrap gap-2">
      <button class="btn btn-outline-primary btn-sm" (click)="alterarAno(-1)">
        <i class="fa fa-chevron-left"></i>
      </button>
      <span class="ano-pill">{{ ano }}</span>
      <button class="btn btn-outline-primary btn-sm" (click)="alterarAno(1)">
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>

    <div class="saldo-inicial-group">
      <label>Saldo inicial do caixa em 01/01</label>
      <input type="number" class="form-control form-control-sm" [(ngModel)]="saldoInicialPeriodo" />
    </div>

    <div class="previsao-real-group">
      <label>Tipo de lancamento</label>
      <div class="btn-group btn-group-sm">
        <button
          type="button"
          class="btn btn-outline-secondary"
          [class.active]="filtroPrevisaoReal === 'T'"
          (click)="selecionarPrevisaoReal('T')">
          Todos
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary"
          [class.active]="filtroPrevisaoReal === 'R'"
          (click)="selecionarPrevisaoReal('R')">
          Real
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary"
          [class.active]="filtroPrevisaoReal === 'P'"
          (click)="selecionarPrevisaoReal('P')">
          Previsao
        </button>
      </div>
    </div>

    <button class="btn btn-primary btn-sm" (click)="carregarRelatorio()">
      <i class="fa fa-refresh"></i> Atualizar
    </button>
  </div>

  <div class="resumo-relatorio">
    <div class="resumo-box">
      <div class="resumo-label">Saldo do dia:</div>
      <div class="resumo-data">{{ saldoDiaData || '-' }}</div>
      <div class="resumo-valor">R$ {{ formatMoney(saldoDiaValor) }}</div>
    </div>
    <div class="resumo-box">
      <div class="resumo-label">Saldo final do periodo:</div>
      <div class="resumo-data">{{ saldoFinalData || '-' }}</div>
      <div class="resumo-valor">R$ {{ formatMoney(saldoFinalValor) }}</div>
    </div>
  </div>

  <div
    #tabelaScroll
    class="card-box table-responsive"
    [class.dragging-table]="arrastandoTabela"
    (mousedown)="iniciarArrasteTabela($event, tabelaScroll)"
    (mousemove)="moverArrasteTabela($event, tabelaScroll)"
    (mouseup)="encerrarArrasteTabela()"
    (mouseleave)="encerrarArrasteTabela()">
    <table class="table table-bordered table-sm table-hover fluxo-diario-table">
      <thead>
        <tr>
          <th>Data</th>
          <th>Dia da semana</th>
          <th>Saldo inicial</th>
          <th>A receber do dia</th>
          <th>A pagar do dia</th>
          <th>Saldo final</th>
          <th>Contas a receber</th>
          <th>Ch. pre a receber</th>
          <th>Contas a pagar</th>
          <th>Ch. pre a pagar</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading">
          <td colspan="10" class="text-center text-muted py-3">Carregando...</td>
        </tr>
        <tr *ngIf="!loading && !linhas.length">
          <td colspan="10" class="text-center text-muted py-3">Nenhum dado encontrado para o periodo.</td>
        </tr>
        <tr *ngFor="let linha of linhas">
          <td>{{ linha.dataExibicao }}</td>
          <td class="text-capitalize">{{ linha.diaSemana }}</td>
          <td>R$ {{ formatMoney(linha.saldoInicial) }}</td>
          <td>R$ {{ formatMoney(linha.receberDia) }}</td>
          <td>R$ {{ formatMoney(linha.pagarDia) }}</td>
          <td class="col-saldo-final">R$ {{ formatMoney(linha.saldoFinal) }}</td>
          <td>R$ {{ formatMoney(linha.contasReceber) }}</td>
          <td>R$ {{ formatMoney(linha.chequePreReceber) }}</td>
          <td>R$ {{ formatMoney(linha.contasPagar) }}</td>
          <td>R$ {{ formatMoney(linha.chequePrePagar) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
